import { useQuery } from "@tanstack/react-query";
import { CACHE_KEY_DOCUMENTTEMPLATE } from "../../../../utils/constants";
import { DocumentTemplateInterface } from "../../../../models/ProcurementModule/DocumentTemplate";
import documentTemplateService from "../../../../services/general/documentTemplateService";

const useDocumentTemplateById = (id: string | undefined) =>
  useQuery<DocumentTemplateInterface, Error>({
    queryKey: [`${CACHE_KEY_DOCUMENTTEMPLATE}ById`, id],
    queryFn: ({ queryKey }) => {
      const [, itemId] = queryKey;
      return documentTemplateService.GetById(itemId as string);
    },
    enabled: !!id,
  });

export default useDocumentTemplateById;
